import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-supporter',
  templateUrl: './supporter.component.html',
  styleUrls: ['./supporter.component.scss']
})
export class SupporterComponent implements OnInit {

  @Input() public fundraiser;
  @Input() public supporters;
  @Input() public isFundraiserEnded;
  @Input() public isLoading;
  @Input() public donateBtnLabel;
  @Input() public settings;
  @Input() public view;

  constructor() { }

  ngOnInit() {
  }

  checkLenth(arr, length) {
    return arr?.data && arr?.data?.length >= length ? false : true;
  }

}
